var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 180 180",
    style: {
      enableBackground: "new 0 0 180 180"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#6A6B6C;stroke-width:12.3364;stroke-miterlimit:10;}\n\t.st1{fill:#5A595B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M146.3,147.9c-32,31.1-83.1,30.3-114.2-1.6C1,114.3,1.7,63.2,33.7,32.1s83.1-30.3,114.2,1.6 C178.9,65.6,178.3,116.8,146.3,147.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M93,76.5c-3.2-1.8-6.3-1.3-9.2-1.4c-8.5-0.4-16.3,1.4-23.4,6.3c-2.6,1.8-5.5,3.1-8.3,4.4 c-1.3,0.6-2.8,1.2-4.3,1.2c-2.5,0-5.3-0.3-6.5-3c-1.1-2.7,1.6-3.7,3-5c6.1-5.2,12.6-9.7,19.5-13.6c6.9-3.9,14.3-5.6,22.2-5.6 c3.3,0,6.7-0.4,9.9,0.1c10,1.7,17.8-2.2,24.3-9.2c1.7-1.8,2.8-2,4.7-0.1c4.3,4.4,8.9,8.7,13.5,12.8c1.6,1.3,2.1,2.4,0.7,4.3 c-2.2,3-4,6.1-6.1,9.1c-5.5,8.1-13.1,11.8-23.1,12.1c-10.7,0.4-21.5,0.9-32,3.8c-1.6,0.4-3.2,0.8-4.5-0.6c-1.3-1.6-0.4-3.2,0.1-4.7 c1.9-4.7,6-6.5,10.4-7.9C86.8,78.6,89.9,78.7,93,76.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M110.3,105.9c2.6-1,5.4-1.6,7.7-3c2.9-1.8,5.1-1.1,7.6,0.5c4.3,2.8,8.4,5.6,11.9,9.8 c-3.2,2.8-6.9,4.5-10.7,6.1c-6.2,2.8-12.7,4.8-19.3,6.8c-3,0.8-5,0.4-7-1.8c-1.1-1.3-2.5-2.6-4.4-3.2c-0.4,2.6,2,4,2.5,6.4 c-17.9,2.2-34-1.5-47.9-12.9c-4.8-4-9.9-6.8-15.4-9.2c-1.3-0.6-2.5-1.1-3.6-2.2c13.8,4.1,27.5,8.7,41.9,10 c14.2,1.2,28.4,3.2,42.6-0.1c-22.2-0.4-44.1-3.7-66.5-9c5.3-3.3,10.6-4.9,15.6-6.9c1.6,4.4,3.2,5.4,8.5,4.3 c8.2-1.8,16.4-3.3,24.7-4c1.2-0.1,2.4-0.1,4.1-0.4c-2.8,3.1-6,5.1-8.3,8.8c5.2-1.5,9.2-4.2,12.9-6.8c3.5-2.4,6.5-3,9.9,0.1 c-2,2.5-5.4,3.3-7.3,6c-0.1,0.2-0.2,0.4-0.3,0.7C109.7,105.9,110,105.9,110.3,105.9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoft);
export default __webpack_public_path__ + "static/media/soft.98e8c00ffbedd3b86ef2671d9f4999f8.svg";
export { ForwardRef as ReactComponent };